import React from 'react';
import { Alert, Card, CardHeader, Skeleton } from '@opendate-app/setlist';

const wholeUsd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
const centsUsd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
const shortDate = (iso) => new Date(`${iso}T00:00:00`).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

const ROW_STYLE = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderTop: '1px solid var(--sl-border-secondary)', fontSize: 13,
};

function PayoutPanel({ payout }) {
  return (
    <div style={{ background: 'var(--sl-bg-brand-primary)', borderRadius: 8, padding: '12px 14px', marginBottom: 4 }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--sl-text-brand)' }}>
        {payout ? `Next payout · ${shortDate(payout.arrives_on)}` : 'No payout scheduled'}
      </div>
      {payout && <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--sl-text-primary)' }}>{centsUsd.format(payout.amount)}</div>}
    </div>
  );
}

function MoneyCard({ data, loading, error, href, allRooms }) {
  const rows = data && [
    ['Settlements closed', `${data.settlements.paid} of ${data.settlements.total}`],
    ['Refunds issued', `${wholeUsd.format(data.refunds.amount)} · ${data.refunds.count}`],
    ['Open chargebacks', `${data.chargebacks.count} · ${wholeUsd.format(data.chargebacks.amount)}`],
    ['Sales tax collected', wholeUsd.format(data.sales_tax)],
  ];

  return (
    <Card style={{ height: '100%' }} header={<CardHeader title={<a href={href} style={{ color: 'inherit' }}>Money →</a>} supportingText={allRooms ? 'Payouts, settlements, and leakage · Not filtered by room' : 'Payouts, settlements, and leakage'} />}>
      {loading && <Skeleton width="100%" height={200} />}
      {!loading && error && <Alert color="error" title="Couldn't load money" description="Refresh the page to try again." />}
      {!loading && !error && data && (
        <>
          <PayoutPanel payout={data.next_payout} />
          {rows.map(([label, value]) => (
            <div key={label} style={ROW_STYLE}>
              <span style={{ color: 'var(--sl-text-secondary)' }}>{label}</span>
              <span style={{ fontWeight: 600, color: 'var(--sl-text-primary)' }}>{value}</span>
            </div>
          ))}
        </>
      )}
    </Card>
  );
}

export default MoneyCard;
